/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .assignments-list {
    display: flex;
    flex-direction: column;
  }

  .assignment-row {
    padding: 12px 16px;
    border-bottom: 1px solid ${$.gray100};

    &:last-child {
      border-bottom: none;
    }

    .assignment-role-label {
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.8px;
      color: ${$.gray500};
      margin-bottom: 8px;
    }

    .assignment-user-row {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .assignment-avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: ${$.primaryMain};
      color: ${$.white};
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      font-weight: 700;
      flex-shrink: 0;
      letter-spacing: 0;
    }

    .assignment-select {
      flex: 1;
      min-width: 0;
      height: 34px;
      border: 1px solid ${$.cardBorderColor};
      border-radius: 6px;
      padding: 0 8px;
      font-size: 13px;
      color: ${$.gray700};
      background: ${$.white};
      cursor: pointer;
      transition: border-color 0.15s;

      &:not(:disabled):focus {
        outline: none;
        border-color: ${$.primaryMain};
        box-shadow: 0 0 0 3px ${$.primaryMain}33;
      }

      &:disabled {
        background: ${$.gray100};
        cursor: default;
        color: ${$.gray600};
      }
    }

    .assignment-loading {
      padding: 4px 0;
    }
  }
`;
